var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../../Infra/RemoteData";
import { NamedRoutes } from "../NamedRoutes";
export class GlobalAdminJobManagementViewModel {
    constructor(container) {
        this.currentTab = "queues";
        this.confirmDeleteQueue = null;
        this.confirmPurgeQueue = null;
        this.routingUIManager = container.routingUIManager;
        this.jobManagementManager = container.jobManagementManager;
    }
    get queues() {
        return this.jobManagementManager.queues.value;
    }
    get schedules() {
        return this.jobManagementManager.schedules.value;
    }
    get actionLoading() {
        return this.jobManagementManager.actionLoading;
    }
    get lastActionResult() {
        return this.jobManagementManager.lastActionResult;
    }
    get totalQueueCount() {
        if (this.queues === NOT_LOADED)
            return 0;
        return this.queues.length;
    }
    get totalScheduleCount() {
        if (this.schedules === NOT_LOADED)
            return 0;
        return this.schedules.length;
    }
    get totalFailedJobs() {
        if (this.queues === NOT_LOADED)
            return 0;
        return this.queues.reduce((sum, q) => sum + q.failedCount, 0);
    }
    get totalActiveJobs() {
        if (this.queues === NOT_LOADED)
            return 0;
        return this.queues.reduce((sum, q) => sum + q.activeCount, 0);
    }
    get totalPendingJobs() {
        if (this.queues === NOT_LOADED)
            return 0;
        return this.queues.reduce((sum, q) => sum + q.pendingCount, 0);
    }
    get totalJobs() {
        if (this.queues === NOT_LOADED)
            return 0;
        return this.queues.reduce((sum, q) => sum + q.size, 0);
    }
    setCurrentTab(tab) {
        this.currentTab = tab;
    }
    refresh() {
        this.jobManagementManager.refresh();
    }
    clearActionResult() {
        this.jobManagementManager.clearLastActionResult();
    }
    viewQueueDetail(queueName) {
        this.routingUIManager.navigateTo(NamedRoutes.GLOBAL_ADMIN_QUEUE_DETAIL, { queueName });
    }
    showDeleteConfirmation(queueName) {
        this.confirmDeleteQueue = queueName;
    }
    hideDeleteConfirmation() {
        this.confirmDeleteQueue = null;
    }
    async confirmDelete() {
        if (this.confirmDeleteQueue) {
            await this.jobManagementManager.deleteQueue(this.confirmDeleteQueue);
            this.confirmDeleteQueue = null;
        }
    }
    showPurgeConfirmation(queueName) {
        this.confirmPurgeQueue = queueName;
    }
    hidePurgeConfirmation() {
        this.confirmPurgeQueue = null;
    }
    async confirmPurge() {
        if (this.confirmPurgeQueue) {
            await this.jobManagementManager.purgeQueue(this.confirmPurgeQueue);
            this.confirmPurgeQueue = null;
        }
    }
    formatCronDescription(cron) {
        const parts = cron.split(" ");
        if (parts.length !== 5)
            return cron;
        const [minute, hour, dayOfMonth, month, dayOfWeek] = parts;
        if (minute === "0" && hour === "*" && dayOfMonth === "*" && month === "*" && dayOfWeek === "*") {
            return "Every hour";
        }
        if (minute === "*/5" && hour === "*" && dayOfMonth === "*" && month === "*" && dayOfWeek === "*") {
            return "Every 5 minutes";
        }
        if (minute === "*/15" && hour === "*" && dayOfMonth === "*" && month === "*" && dayOfWeek === "*") {
            return "Every 15 minutes";
        }
        if (minute === "*/30" && hour === "*" && dayOfMonth === "*" && month === "*" && dayOfWeek === "*") {
            return "Every 30 minutes";
        }
        if (minute === "0" && hour === "0" && dayOfMonth === "*" && month === "*" && dayOfWeek === "*") {
            return "Daily at midnight";
        }
        if (minute === "0" && hour === "0" && dayOfMonth === "*" && month === "*" && dayOfWeek === "0") {
            return "Weekly on Sunday";
        }
        return cron;
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], GlobalAdminJobManagementViewModel.prototype, "currentTab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GlobalAdminJobManagementViewModel.prototype, "confirmDeleteQueue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GlobalAdminJobManagementViewModel.prototype, "confirmPurgeQueue", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "queues", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "schedules", null);
__decorate([
    computed,
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "actionLoading", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "lastActionResult", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "totalQueueCount", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "totalScheduleCount", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "totalFailedJobs", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "totalActiveJobs", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "totalPendingJobs", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], GlobalAdminJobManagementViewModel.prototype, "totalJobs", null);
